import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetAssessmentsQuestionsQuery } from 'services/assessmentsService';
import { selectAssessmentsId } from '../assessmentsAuthSlice';
import { useAssessmentsParams } from './useAssessmentsParams';

export const useAssessmentsQuestions = () => {
  const assessmentsId = useSelector(selectAssessmentsId);
  const { tenantId } = useAssessmentsParams();

  const skipQuery = useMemo(
    () =>
      tenantId && assessmentsId
        ? {
            surveyId: assessmentsId,
            tenantId,
          }
        : skipToken,
    [tenantId, assessmentsId],
  );

  const {
    data: assessmentsQuestionsResponse,
    isFetching: isAssessmentsQuestionsLoading,
    error: assessmentsQuestionsError,
    refetch,
  } = useGetAssessmentsQuestionsQuery(skipQuery);

  const questions = useMemo(() => {
    if (!assessmentsQuestionsResponse) return [];
    return assessmentsQuestionsResponse.questions;
  }, [assessmentsQuestionsResponse]);

  return {
    loading: isAssessmentsQuestionsLoading,
    error: assessmentsQuestionsError,
    assessmentsQuestionsResponse,
    questions,
    refetchQuestions: refetch,
  };
};
